import $ from 'jquery';

class RouteChart{

    constructor(container){

        this.container = container;
        this.canvas = $('<canvas height="100"></canvas>');
        this.container.append(this.canvas);
        this.myChart = null;

    }

    render(route){

        let self = this;

        if(
            route.route_speeds.length === 0 &&
            route.route_altitudes.length === 0
        ) return false;

        const charts = {
            speeds: {
                label: 'Speed',
                data: []
            },
            altitudes: {
                label: 'Altitude',
                data: []
            }
        };

        const interval = Math.floor(route.route_distance / 6);

        let lablesBlock = $('<div class="chartLablesBlock"></div>');
        self.container.append(lablesBlock);
        for(let it = 0; it < 6; it++){
            lablesBlock.append($('<div>' + Math.round(interval * it / 100) / 10 + '' + (it === 0 ? 'km' : '') + '</div>'));
        }
        lablesBlock.append($('<div>' + Math.round(route.route_distance / 100) / 10 + '</div>'));

        let i = 0;
        route.route_path.forEach((section, sectionIndex) => {
            section['path'].forEach((position, positionIndex) => {

                if(route.route_speeds.length > 0){
                    charts.speeds.data.push({
                        x: i.toString(),
                        y: Number.parseInt(route.route_speeds[sectionIndex][positionIndex]).toString(),
                        position: position
                    })
                }

                if(route.route_altitudes.length > 0){
                    charts.altitudes.data.push({
                        x: i.toString(),
                        y: Number.parseInt(route.route_altitudes[sectionIndex][positionIndex]).toString(),
                        position: position
                    })
                }

                i++;
            })
        })

        const chartTabs = $('<div class="chartTabButtons"></div>');
        self.container.append(chartTabs);

        let altitudeActive = false;

        if(charts.speeds.data.length > 0){
            let speedsTab = $('<div class="item speedsTab">' + charts.speeds.label + '</div>');
            speedsTab.on('click', function(){
                chartTabs.find('.item').removeClass('active');
                $(this).addClass('active');
                self.initChart(charts.speeds.data);
            })
            chartTabs.append(speedsTab);
            speedsTab.click();
        }else{
            altitudeActive = true;
        }

        if(charts.altitudes.data.length > 0){
            let altitudesTab = $('<div class="item altitudesTab">' + charts.altitudes.label + '</div>');
            altitudesTab.on('click', function(){
                chartTabs.find('.item').removeClass('active');
                $(this).addClass('active');
                self.initChart(charts.altitudes.data);
            })
            chartTabs.append(altitudesTab)
            if(altitudeActive){
                altitudesTab.click();
            }
        }

    }

    initChart(lineData){

        let self = this;

        const data = {
            datasets: [{
                label: 'chart',
                data: lineData,
                borderColor: '#1aa7ec',
                borderWidth: 2,
                fill: false,
                pointRadius: 0, // Размер точек
            }]
        };

        const options = {
            scales: {
                x: {display: false},
                y: {display: false}
            },
            plugins: {
                legend: {display: false},
                tooltip: {
                    displayColors: false,
                    animation: false,
                    xAlign: 'center',
                    yAlign: 'top',
                    intersect: false, // Всплывать на ближайшей точке в пределах направления
                    mode: 'index', // Показывать подсказку для всех точек в вертикальной линии
                    position: 'nearest', // Всплывать на ближайшей точке
                    callbacks: {
                        title: function () {
                            return '';
                        },
                        label: function (data) {
                            if(data.raw){
                                $(self.container).trigger('onHoverPoint', [data.raw.position]);
                                return data.raw.y;
                            }
                        }
                    }
                },
            },
        };

        if(self.myChart){
            self.myChart.destroy();
        }
        const ctx = self.canvas[0].getContext('2d');
        self.myChart = new Chart(ctx, {
            type: 'line',
            data: data,
            options: options
        });

    }

}

export default RouteChart;